<template>
    <div>
        <div ref="component" id="myChart3"></div>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp"
import request from "@/utils/request.js"
import { isDate } from "moment"

export default {
    props: ["dataTime1"],
    data() {
        this.isEchart = ""
        return {
            specialtyList: [],
            usernameLsit: [],
            countOneList: [],
            count1List: [],
            countThreeList: [],
            leq30List: [],
            leq60List: [],
            leq80List: [],
            gt80List: [],
        }
    },
    watch: {
        dataTime1() {
            this.getPlayback()
        },
    },
    created() {},
    mounted() {
        // this.drawLine();
        this.getPlayback()
    },
    methods: {
        async getPlayback() {
            const res = await post("/jjyl/traffic/callInfo/info/getCallCount", {
                outCall: 0,
            })
            const { code, content } = res
            console.log(res.content, "asadc")
            if (code === 200) {
                let huchuList = res.content
                let one = []
                let two = []
                one.push(
                    huchuList.time1,
                    huchuList.time2,
                    huchuList.time3,
                    huchuList.time4,
                    huchuList.time5,
                    huchuList.time6
                )
                two.push(
                    huchuList.callCount1,
                    huchuList.callCount2,
                    huchuList.callCount3,
                    huchuList.callCount4,
                    huchuList.callCount5,
                    huchuList.callCount6
                )
                this.drawLine(one, two)
            }
        },
        drawLine(one, two) {
            console.log(one, two)
            this.isEchart = this.$echarts.init(
                document.getElementById("myChart3")
            )
            this.$echarts.init(this.$refs.component, null, {
                renderer: "canvas",
            })
            // 绘制图表
            this.isEchart.setOption({
                // title: {},
                // tooltip: {
                //   trigger: 'axis',
                //   axisPointer: {
                //     type: 'shadow'
                //   }
                // },
                // grid: {
                //   left: '3%',
                //   right: '4%',
                //   bottom: '3%',
                //   containLabel: true
                // },
                yAxis: {
                    type: "value",
                    name: "次",
                },
                xAxis: {
                    type: "category",
                    data: one,
                    name: "时",
                },
                series: {
                    type: "line",
                    smooth: true,
                    data: two,
                },
            })
        },
    },
    beforeDestroy() {
        if (this.isEchart) {
            this.isEchart.clear()
        }
    },
}
</script>

<style lang='less' scoped>
#myChart3 {
    width: 100%;
    height: 460px;
}
</style>
